import React, { useMemo } from 'react';
import { secondsToTime } from 'utils';
import useUser from 'hooks/redux/useUser';
import { Box, Table } from '@missionlabs/smartagent-app-components';
import { ToolBar, NoDataMessage } from 'components';
import { useGetFeatureConfig, AppFeatures } from 'hooks/useHasFeature';
import useContactPanelContext from 'views/ContactPanel/useContactPanelContext';

interface Props {}

const AgentStats: React.FC<Props> = props => {
    const { agentContactStatsByQueue } = useUser();

    const { agentsOpen, setAgentsOpen } = useContactPanelContext();

    const config = useGetFeatureConfig()(AppFeatures.QUEUE_STATS);

    const agentTableStats = useMemo(
        () =>
            agentContactStatsByQueue?.map((queueStats, i) => ({
                ID: i.toString(),
                queue: queueStats.queueName,
                handled: queueStats.handled,
                contactTime: secondsToTime(queueStats.contactTime),
                avgHandledTime: secondsToTime(queueStats.avgHandledTime),
                avgHoldTime: secondsToTime(queueStats.avgHoldTime),
                avgAcwTime: secondsToTime(queueStats.avgAcwTime),
            })),
        [agentContactStatsByQueue]
    );

    const contactColumns = [
        {
            value: 'queue',
            name: 'Queue',
            sort: true,
        },
        {
            value: 'handled',
            name: 'Handled',
            sort: true,
            tooltip: 'Count of contacts handled by an agent',
        },
        {
            value: 'contactTime',
            name: 'contact time',
            sort: true,
            tooltip: '',
        },
        {
            value: 'avgHandledTime',
            name: 'avg handled time',
            sort: true,
            tooltip: 'Average handled time',
        },
        {
            value: 'avgHoldTime',
            name: 'avg hold time',
            sort: true,
            tooltip: 'Average hold time',
        },
        {
            value: 'avgAcwTime',
            name: 'avg acw time',
            sort: true,
            tooltip: 'Average time agent spent in after contact work',
        },
    ];

    return (
        <>
            {!config?.hideHistoricMetrics && (
                <Box
                    onToggle={setAgentsOpen}
                    controlledHidden={agentsOpen}
                    collapse
                    alt
                    boxLabel="Contacts"
                    header={<ToolBar text="My Contacts" items={[]} />}
                >
                    <Table
                        sort="queue"
                        caption="Agents"
                        cols={contactColumns}
                        data={agentTableStats}
                        noData={<NoDataMessage />}
                    />
                </Box>
            )}
        </>
    );
};

export default AgentStats;
